'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _propTypes=require('prop-types');var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var flashMessageType=_propTypes2.default.shape({id:_propTypes2.default.string.isRequired,message:_propTypes2.default.string.isRequired,isError:_propTypes2.default.bool.isRequired,props:_propTypes2.default.object.isRequired});exports.default=flashMessageType;


//////////////////
// WEBPACK FOOTER
// ./~/redux-flash/lib/flashMessageType.js
// module id = 1355
// module chunks = 168707334958949